import { gql } from "graphql-request";
import graphqlClient from "./graphqlClient";

export interface ProductStatus {
  status:
    | "paid"
    | "past_due"
    | "pending_certification"
    | "cancelled"
    | "pending"
    | "unpaid"
    | "canceled";
}

export interface OrganizationProducts {
  [sku: string]: ProductStatus;
}

export interface OrganizationSettings {
  newSSPSubscriptionPlan?: boolean;
  newFocusSubscriptionPlan?: boolean;
}

export interface Organization {
  id: number;
  name: string;
  productsStatus: OrganizationProducts;
  preferredCurrency: string;
  settings?: OrganizationSettings;
}

export interface GetOrganizationResponse {
  getOrganization: Organization;
}

const GET_ORGANIZATION_QUERY = gql`
  query GET_ORGANIZATION {
    getOrganization {
      id
      name
      productsStatus
      preferredCurrency
      settings
    }
  }
`;

export async function getOrganization(token?: string | null): Promise<Organization> {
  const response = await graphqlClient.request<GetOrganizationResponse>(
    GET_ORGANIZATION_QUERY,
    undefined,
    token,
  );
  return response.getOrganization;
}
